export const PAYMENT_FLOWS = {
  CHECKOUT: "CHECKOUT",
  CODTOPREPAID: "CODTOPREPAID",
  CODTOPREPAID_WHATSAPP: "CODTOPREPAID_WHATSAPP",
  ORDER_PAYMENT_PRE_CONFIRMATION: "ORDER_PAYMENT_PRE_CONFIRMATION",
  NYKAA_WALLET: "NYKAA_WALLET",
  WALLET: "wallet",
  GIFT_CARD: "giftcard",
  COD_TO_PREPAID: "codToPrepaidPayment",
  POST_PAYMENT: "postPayment",
  PAYMENT_SUCCESS: "paymentSuccess",
  MY_SAVEDPAYMENT: "mySavedPayment",
  PRE_CONFORMATION: "preConformation",
  GIFTCARD_STATUS: "giftCardStatus",
  EXPRESS_CHECKOUT: "expressCheckout",
  PCI_OTP: "pciOtp",
};

export const FLOW_COMPONENTS = {
  "MSITE": {
    "CHECKOUT": {
      address: true,
      showPriceDetails: true,
      wallet: true,
      offers: true,
      edd: true,
      showPaymentView: true, // for displaying different payment methods
      showProceedButton: true,
    },
    "giftcard": {
      address: false,
      showPriceDetails: false,
      wallet: false,
      offers: false,
      edd: false,
      showPaymentView: true,
      showProceedButton: false,
    },
    "wallet": {
      address: false,
      showPriceDetails: false,
      wallet: false,
      offers: false,
      edd: false,
      showPaymentView: true,
      showProceedButton: false,
    },
    "codToPrepaidPayment": {
      address: false,
      showPriceDetails: false,
      wallet: false,
      offers: false,
      edd: false,
      showPaymentView: true,
      showProceedButton: false,
    },
  },
  "WEBSITE": {
    "CHECKOUT": {
      address: true,
      wallet: true,
      offers: true,
      edd: true,
      showPaymentView: true,
      showCheckoutHeader: true,
      showGiftCardHeader: false,
      showWalletHeader: false,
      showPriceDetails: true,
      showBagDetails: true,
      showRightSideWalletBalance: false,
      showAuthenticCardDetails: true,
      showOtherOffersCardDetails: true,
      showGiftCardPreview: false,
    },
    "giftcard": {
      address: false,
      wallet: false,
      offers: false,
      edd: false,
      showPaymentView: true,
      showCheckoutHeader: false,
      showGiftCardHeader: true,
      showWalletHeader: false,
      showPriceDetails: false,
      showBagDetails: false,
      showRightSideWalletBalance: false,
      showAuthenticCardDetails: false,
      showOtherOffersCardDetails: false,
      showGiftCardPreview: true,
    },
    "wallet": {
      address: false,
      wallet: false,
      offers: false,
      edd: false,
      showPaymentView: true,
      showCheckoutHeader: false,
      showGiftCardHeader: false,
      showWalletHeader: true,
      showPriceDetails: false,
      showBagDetails: false,
      showRightSideWalletBalance: true,
      showAuthenticCardDetails: true,
      showOtherOffersCardDetails: false,
      showGiftCardPreview: false,
    },
    "codToPrepaidPayment": {
      address: false,
      wallet: false,
      offers: false,
      edd: false,
      showPaymentView: true,
      showCheckoutHeader: true,
      showGiftCardHeader: false,
      showWalletHeader: false,
      showPriceDetails: false,
      showBagDetails: false,
      showRightSideWalletBalance: false,
      showAuthenticCardDetails: false,
      showOtherOffersCardDetails: false,
      showGiftCardPreview: false,
    },
  },
};

export const PAYMENT_METHODS = {
  COD: "cash",
  CREDIT_CARD: "cc",
  DEBIT_CARD: "dc",
  GIFT_CARD: "gift",
  MOBIKWIK: "mobikwik",
  NET_BANKING: "nb",
  NYKAA_WALLET: "nykaa_wallet",
  PAYTM: "paytm",
  PAYTM_AUTO_DEBIT: "paytm_auto_debit",
  PAY_U_MONEY: "payumoney",
  PAY_ZAPP: "payzapp",
  UPI: "upi",
  UPI_INTENT: "upi_intent",
  BHIM_UPI: "BHIM UPI",
  UPI_AXIS_BANK: "axis_bank_upi",
  GOOGLE_PAY: "googlePay",
  PHONE_PE: "phonePe",
  SIMPL: "simpl",
  ZEST: "zest_money",
  SNPL: "snpl",
  ZEST_MONEY: "zest_money",
  EMI: "emi",
  PREFERRED: "preferred",
  CRED_PAY_UPI: "credPayUpi",
  ICICI: "icici",
  BHIM: "bhim",
  C_O_D: "COD",
  QR: "QR",
};

export const PAYMENT_METHODS_NAME = {
  CC: "Credit Card",
  COD: "Cash on Delivery",
  DC: "Debit Card",
  NB: "Net Banking",
  WALLET: "Wallet",
  NYKAA_WALLET: "Nykaa Wallet",
  FREE: "Cash on Delivery",
  UPI: "UPI",
  UPI_INTENT: "UPI INTENT",
  PAYTM: "Paytm",
  PAYTM_AUTO_DEBIT: "Paytm Auto Debit",
  PAYTM_PG: "Paytm PG",
  PREPAID: "Prepaid",
  ZEST_MONEY: "Zest Money",
  EMI: "EMI",
  GIFT_CARD: "Gift Card",
  SIMPL: "simpl",
};

export const PAYMENT_METHOD_MAPPING = {
 [PAYMENT_METHODS.CREDIT_CARD]: "Card",
 [PAYMENT_METHODS.DEBIT_CARD]: "Card",
 [PAYMENT_METHODS.UPI]: "UPI",
 [PAYMENT_METHODS.NET_BANKING]: "NetBanking",
 [PAYMENT_METHODS.PAYTM]: "Paytm",
 [PAYMENT_METHODS.C_O_D]: "COD",
 [PAYMENT_METHODS.GIFT_CARD]: "GiftCard",
 [PAYMENT_METHODS.SNPL]: "ShopNowPayLater",
 [PAYMENT_METHODS.ZEST_MONEY]: "Zest",
 [PAYMENT_METHODS.NYKAA_WALLET]: "wallet",
 [PAYMENT_METHODS.EMI]: "Emi",
 [PAYMENT_METHODS.QR]: "QR",
 [PAYMENT_METHODS.PREFERRED]: "SavedPaymentMenthod",
};

export const PAYMENT_TYPE = {
  PCI: "pci",
  NON_PCI: "non_pci",
};

/**
 * upi method name irrespective of upiMapping titles. it is for upi intent.
 */
export const UPI_METHODS: any = {
  "Google Pay": PAYMENT_METHODS.GOOGLE_PAY,
  "PhonePe": PAYMENT_METHODS.PHONE_PE,
  "ICICI": PAYMENT_METHODS.ICICI,
  "BHIM": PAYMENT_METHODS.BHIM,
  "Paytm": PAYMENT_METHODS.PAYTM,
  "CRED Pay UPI": PAYMENT_METHODS.CRED_PAY_UPI,
};
export const RECOMMENDED_PAYMENT = "Recommended method";
